// Fonts declaration

const fontNormal = 'Graphik, Helvetica, Arial, sans-serif';

export default {
  fontNormal,
};
